module.exports = __webpack_public_path__ + "static/media/comprehensive-welness-logo-new@3x.c5b8b044.png";